// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3cQ7c","question":"Question_question__3CVYW","description":"Question_description__3WouB"};